import { Flex, Typography, Card } from "antd";
import Chart from "react-apexcharts";
import React from "react";

export default function RevenuePerTreatmentType() {
  return (
    <Card style={{ minWidth: 351, height: 350 }}>
      <Flex vertical>
        <Typography.Title level={4}>Revenue per Treatment Type</Typography.Title>
        <RevenuePerTreatmentTypeChart />
      </Flex>
    </Card>
  );
}

const RevenuePerTreatmentTypeChart = () => {
  const series = [
    {
      name: "Revenue",
      data: [4000, 2500, 1200, 3200, 4800, 4200], // Your revenue values
    },
  ];

  const options = {
    chart: {
      type: "bar",
      height: 200,
      toolbar: { show: false },
      zoom: { enabled: false },
      parentHeightOffset: 0, // Removes bottom white gap
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "26%", // Thin bars (exact match)
        borderRadius: 6,
        endingShape: "rounded",
        distributed: false,
      },
    },
    dataLabels: { enabled: false },
    stroke: {
      show: true,
      width: 1,
      colors: ["transparent"],
    },
    colors: ["#722ed1"], // Exact purple
    xaxis: {
      categories: ["Scaling", "Root Planing", "Root Planing", "Root Planing", "Root Planing", "Root Planing"],
      labels: {
        rotate: -45,
        rotateAlways: true,
        axisBorder: { show: false },
        style: {
          fontSize: "12px",
          fontWeight: 500,
          colors: "#979797",
        },
      },
      axisBorder: { show: false },
      axisTicks: { show: false },
    },
    yaxis: {
      min: 0,
      max: 5000,
      tickAmount: 5,
      labels: {
        formatter: function (val) {
          if (val === 0) return "0";
          return (val / 1000).toFixed(0) + "K";
        },
        style: {
          colors: "#979797",
          fontSize: "12px",
        },
      },
    },
    grid: { show: false },
    legend: { show: false },
    tooltip: {
      enabled: true,
      y: {
        formatter: function (val) {
          return "$" + val.toLocaleString();
        },
      },
    },
    fill: { opacity: 1 },
  };

  return <Chart options={options} series={series} type="bar" height={290} />;
};
